import React from "react";
import {CircularProgress, Stack, Link} from "@mui/joy";
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";


// components
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import {deleteArrayItemByKeyValue, retrieveModelField, setArrayKey} from "../../utils/misc";


class MaterialSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            query: '',
            formFields: null,
        };
    }

    async componentDidMount() {
        await this.retrieveForm();
    }

    async retrieveForm(){
        const url = 'material/update_form/';
        const api = new BaseApi();
        let params = {
            fields: JSON.stringify(
            [
                    'xtype',
                ]
            )
        }
        let response = await api.get(url, params);
        let fields = response.data
        fields = deleteArrayItemByKeyValue(
            fields,
            'name',
            'submitButton'
        );
        fields = [
            {
                'name': 'query',
                'label': 'Запрос',
                'xs': 12,
                'sm': null,
                'md': 9,
                'lg': null,
                'xl': null,
                'required': true,
                'default': this.state.query,
                'type': 'input',
            },
            {
                'name': 'top_k',
                'label': 'Колическтво результатов',
                'xs': 12,
                'sm': null,
                'md': 3,
                'lg': null,
                'xl': null,
                'required': true,
                'default': 100,
                'type': 'input',
            },
            ...fields
        ]
        let mlhostField = await retrieveModelField(
            'mlhost',
            {
                page_size: 10000,
            },
            'mlhost',
            'Ml Host',
            'id',
            ['title',],
            '---',
            null,
            true
        )
        mlhostField.default = 1;
        fields.push(mlhostField)
        fields.push(
            {
                'type': 'submit',
                'label': 'Искать',
            }
        )
        this.setState({
            formFields: fields
        })
    }

    async performSearch(data) {
        const url = 'material/search/';
        const api = new BaseApi();
        let response = await api.post(url, data);
        if (response.status === 200){
            return response.data
        }
        else{
            return []
        }
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        let results = await this.performSearch(
            formDataObj
        );
        this.setState({
            results: results,
            query: formDataObj.query,
        });
    }

    render() {
        if (!this.state.formFields) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={1}
            >
                <CommonForm
                    fields={this.state.formFields}
                    processForm={this.processForm.bind(this)}
                />
                {
                    this.state.results.map(r => (
                        <Card>
                            <Typography>
                                <strong>{r.score}</strong>
                                <Link
                                    sx={{
                                        display: 'inline',
                                        ml: 1,
                                    }}
                                    target={'_blank'}
                                    href={'/material/detail/' + r.material}
                                >
                                    {r.material_title}
                                </Link>
                            </Typography>
                            <Typography>
                                {r.text}
                            </Typography>
                        </Card>
                    ))
                }

            </Stack>
        )
    }
}

export default MaterialSearch
